const riot = require('riot');

riot.tag2('popup-record-edit', '<div class="relative" ref="popup"> <div ref="edit" data-is="module-record-edit" item="{opts.item}"></div> <div class="absolute t20 r24 cursor-pointer" if="{!opts.item.record}" onclick="{close}"><i class="icon-close fs20 text-label_medium"></i></div> </div>', 'popup-record-edit,[data-is="popup-record-edit"]{display:block}', '', function(opts) {
    this.on('mount', () => {
      this.refs.edit.on('submit', (data) => {
        this.trigger('submit', data);
        this.close();
      });

      this.refs.edit.on('create', (data) => {
        this.trigger('create', data);
        this.close();
      });

      this.refs.edit.on('delete', () => {
        this.trigger('delete');
        this.close();
      });

      this.refs.edit.on('close', () => {
        this.close();
      });
    });
});